import { useParams, Link } from "react-router-dom";
import { getAnimeByCategory, animeCategories } from "@/mocks/anime";
import SEOHead from "@/components/base/SEOHead";

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const currentCategory = animeCategories.find((c) => c.slug === slug);
  const animeList = slug ? getAnimeByCategory(slug) : [];

  const categoryName = currentCategory?.name || "分类";
  const pageTitle = `${categoryName}动漫 | 51动漫${categoryName}在线观看与下载 | 51动漫官网`;
  const pageDesc = `51动漫官网${categoryName}分类——提供${categoryName}动漫在线观看和下载服务，海量${categoryName}动漫全集免费资源，支持下拉式阅读，每日更新热门${categoryName}动漫。`;

  return (
    <main className="pt-16 min-h-screen bg-background-50">
      <SEOHead
        title={pageTitle}
        description={pageDesc}
        keywords={`51动漫官网,${categoryName}动漫,${categoryName}动漫在线观看,${categoryName}动漫下载,动漫全集,免费动漫`}
        canonicalUrl={`https://www.51anime.com/category/${slug}`}
      />
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-8">
        <nav className="flex items-center gap-2 text-xs text-foreground-500 mb-6" aria-label="面包屑导航">
          <Link to="/" className="hover:text-primary-500 transition-colors">首页</Link>
          <i className="ri-arrow-right-s-line"></i>
          <span className="text-foreground-700 font-medium">{currentCategory?.name || "分类"}</span>
        </nav>

        <div className="flex items-center gap-3 mb-2">
          <div className="w-10 h-10 flex items-center justify-center bg-primary-100 rounded-xl">
            <i className={`${currentCategory?.icon || "ri-movie-2-line"} text-xl text-primary-500`}></i>
          </div>
          <div>
            <h1 className="text-2xl md:text-3xl font-bold text-foreground-950">
              {currentCategory?.name}动漫
            </h1>
            <p className="text-sm text-foreground-500 mt-0.5">共 {animeList.length} 部作品</p>
          </div>
        </div>

        <div className="flex items-center gap-2 flex-wrap mb-8 mt-6">
          {animeCategories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                cat.slug === slug
                  ? "bg-primary-500 text-white"
                  : "bg-white text-foreground-600 hover:bg-background-100 border border-background-200"
              }`}
            >
              <i className={`${cat.icon} mr-1.5`}></i>
              {cat.name}
            </Link>
          ))}
        </div>

        {animeList.length === 0 ? (
          <div className="text-center py-20">
            <div className="w-20 h-20 mx-auto mb-4 flex items-center justify-center bg-background-200 rounded-full">
              <i className="ri-emotion-sad-line text-3xl text-foreground-400"></i>
            </div>
            <p className="text-foreground-500">暂无该分类的动漫资源</p>
          </div>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-5">
            {animeList.map((anime) => (
              <Link
                key={anime.id}
                to={`/article/${anime.id}`}
                className="group cursor-pointer"
              >
                <div className="relative overflow-hidden rounded-xl aspect-[3/4] mb-3">
                  <img
                    src={anime.coverImage}
                    alt={anime.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    title={`${anime.title} - 51动漫在线观看`}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                  <div className="absolute top-2 left-2">
                    <span className="bg-white/90 text-foreground-950 text-xs font-medium px-2 py-0.5 rounded-md">
                      {anime.status}
                    </span>
                  </div>
                  <div className="absolute bottom-2 left-2 right-2">
                    <div className="flex items-center gap-1 text-white/90 text-xs">
                      <i className="ri-star-fill text-yellow-400 text-xs"></i>
                      <span>{anime.rating}</span>
                      <span className="mx-1 text-white/40">·</span>
                      <span>{anime.episodeCount}</span>
                    </div>
                  </div>
                </div>
                <h3 className="text-sm font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-1">
                  {anime.title}
                </h3>
                <div className="flex items-center gap-1 mt-1">
                  {anime.tags.slice(0, 2).map((tag) => (
                    <span key={tag} className="text-xs text-foreground-400">{tag}</span>
                  ))}
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </main>
  );
}